export default "__VITE_ASSET__DdZE1ek2__"